import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getEntities = state => state.getIn([NAME, 'entities']);
export const getUI = state => state.getIn([NAME, 'ui']);
export const getApp = state => state.getIn([NAME, 'app']);

export const getActive = createSelector(
  getEntities,
  state => getApp(state).get('active'),
  (entities, active) => {
    return active && entities.has(active) ? entities.get(active) : undefined;
  }
);

export const search = createSelector(
  getEntities,
  state => getApp(state).get('search'),
  (entities, search) => {
    entities.filter(location => {
      if (
        location
          .get('name')
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }
      return false;
    });
  }
);

export const searchOrdered = createSelector(search, locations =>
  locations.sortBy(location => location.get('name'))
);

export const getOrdered = createSelector(getEntities, locations =>
  locations.sortBy(location => location.get('name'))
);



// WEBPACK FOOTER //
// ./src/modules/locations/selectors.js